import { IAffiliateCrudModalLang } from '../../../types/lang'

export const affiliateCrudModalLang: IAffiliateCrudModalLang = {
	affiliate_crud_modal: {
		title_edit: 'Edit affiliate',
		title_notes_view: 'View notes for affiliate',
		title_notes_edit: 'Edit notes for affiliate',
		field_name_label: 'Name',
		field_name_placeholder: 'Name',
		field_date_label: 'Date',
		field_date_placeholder: 'Date',
		field_percent_label: 'Percent, %',
		field_percent_placeholder: 'Percent, %',
		field_notes_label: 'Notes',
		field_notes_placeholder: 'Notes',
		btn_add_record: 'Add Record',
		btn_update: 'Save',
		btn_close: 'Close'
	}
}